import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../..//components/ui/card";
import { Badge } from "../../..//components/ui/badge";
import { Button } from "../../..//components/ui/button";
import { CheckCircle, XCircle } from "lucide-react";

export default function QuizResult({ result, questions, onRetake }) {
  const total = questions.length;
  const correct = questions.filter((q) => q.isCorrect).length;
  const score = Number(result?.score ?? (correct / total) * 100).toFixed(2);
  const isPassed = result?.status === 1;

  const getOptionText = (q, label) => {
    if (q.type === "yesno") return label;
    const opt = q.options?.find((o) => o.label === label);
    return opt ? `${opt.label} - ${opt.text}` : label;
  };

  return (
    <div className="mx-auto my-5 space-y-6">
      {/* RESULT CARD */}
      <Card className="rounded-2xl text-center">
        <CardContent className="flex items-center justify-between p-6">
          <div className="flex flex-col items-center">
            {isPassed ? (
              <CheckCircle className="h-16 w-16 text-green-500 animate-pop" />
            ) : (
              <XCircle className="h-16 w-16 text-red-500 animate-pop" />
            )}

            <h2
              className={`mt-2 text-2xl font-bold ${
                isPassed ? "text-green-500" : "text-red-500"
              }`}
            >
              {isPassed ? "PASSED" : "FAILED"}
            </h2>
          </div>

          <div className="flex items-center gap-6">
            <p className="text-xl font-medium">Score: {score}%</p>

            <p className="text-muted-foreground">
              Correct: {correct} / {total}
            </p>

            <Button onClick={onRetake} className="px-5 py-2 text-base">
              Retake Quiz
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* SUMMARY */}
      <Card className="rounded-xl">
        <CardHeader>
          <CardTitle>Quiz Summary</CardTitle>
        </CardHeader>

        <CardContent className="space-y-4">
          {questions.map((q, i) => (
            <div key={q.id} className="flex gap-3">
              <span className="text-lg font-medium">{i + 1}.</span>

              <div className="flex-1">
                <p className="text-base font-semibold mb-1">{q.question}</p>

                <div className="mt-1 flex items-center gap-2">
                  <span className="font-medium">Your Answer:</span>
                  <Badge variant={q.isCorrect ? "success" : "destructive"}>
                    {getOptionText(q, q.selectedAnswer)}
                  </Badge>
                </div>

                {!q.isCorrect && (
                  <div className="mt-1 flex items-center gap-2">
                    <span className="font-medium">Correct Answer:</span>
                    <Badge variant="secondary">
                      {getOptionText(q, q.answer)}
                    </Badge>
                  </div>
                )}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
